import React from 'react';
import type AuthenticationSettingsType from '@atlassian/jira-spa-apps-products-jsm-authentication-settings/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyAuthenticationSettings = lazyForPaint<typeof AuthenticationSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-jsm-authentication-settings", jiraSpaEntry: "async-admin-pages-jsm-authentication-settings" */ '@atlassian/jira-spa-apps-products-jsm-authentication-settings'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyAuthenticationSettings}
		pageId="spa-apps/admin-pages/jsm-authentication-settings"
		shouldShowSpinner={false}
	/>
);
